import React, { useEffect, useState } from 'react';
import throttle from 'lodash/throttle';

import styled from 'styled-components';
import * as palette from './Variables';
import { useLocation } from 'react-router-dom';
import useResize from '../../scenes/VirtualSession/hooks/useResize';

const Wrapper = styled.div``;

const Content = styled.div`
    margin-top: -80px;
    background-color: #fff;
    margin-left: ${props =>
        props.notList || props.issidepanelopened || props.visiblesidemenu ? '16px' : '253px'};
    margin-right: ${props =>
        props.notList || props.issidepanelopened || props.visiblesidemenu ? '16px' : '253px'};
    border-radius: 8px;
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.1), 0 2px 8px 0 rgba(0, 0, 0, 0.05),
        0 0 1px 0 rgba(0, 0, 0, 0.15) !important;
    width: ${props =>
        props.navigationType === 'sideMenu'
            ? props.issidepanelopened
                ? props.visiblesidemenu
                    ? 'calc(100vw - 497px - 258px - 30px)'
                    : 'calc(100vw - 573px - 30px)'
                : 'inherit'
            : props.issidepanelopened && 'calc(100vw - 497px - 30px)'} !important;
    height: ${props =>
        props.viewtype && props.isScrolled
            ? 'calc(100vh - 64px - 26px)'
            : props.viewtype
            ? 'calc(100vh - 280px)'
            : undefined};
    position: relative;
`;

const BackgroundImageWrapper = styled.div`
    position: relative;
    transition: all 1s;
    z-index: -1;
    width: 100%;
    max-height: 280px;
    @media only screen and(max-width: ${palette.MAX_PHONE}) {
        display: none;
    }
`;

const BackgroundImage = styled.img`
    width: 100%;
    height: 100%;
`;

const TitleSection = styled.div`
    position: absolute;
    margin-left: ${props =>
        props.notList || props.issidepanelopened || props.visiblesidemenu ? '16px' : '253px'};
    bottom: 95px;
    z-index: 1;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: left;
    color: #fff;

    div:first-of-type {
        font-family: Cabin, sans-serif;
        font-size: 64px;
        font-weight: bold;
        line-height: 0.75;
    }

    div:nth-of-type(2) {
        font-family: Roboto, sans-serif;
        font-size: 15px;
        font-weight: 500;
        line-height: 1.6;
    }
`;

const BrandingBanner = ({
    notList,
    children,
    backgroundUrl,
    viewType,
    sidePanelOpened,
    visibleFullSideMenu,
    navigationType,
    activeTab,
    title,
    subtitle,
    setTitleOnHeader,
    disableBanner,
}) => {
    const [scrollableElement, setScrollableElement] = useState(null);
    const [isSidepanelOpened, setIsSidepanelOpened] = useState(sidePanelOpened);
    const [isScrolled, setIsScrolled] = useState(false);
    const location = useLocation();
    const { search } = useLocation();
    const bannerWrapperRef = useResize({ ratio: 6 / 1 });

    useEffect(() => {
        setIsSidepanelOpened(sidePanelOpened || (search && !search.includes('?tab=')));
    }, [location, sidePanelOpened]);

    useEffect(() => {
        if (viewType) {
            setTimeout(
                () => {
                    setScrollableElement(
                        document.getElementById(
                            `timetable-scrollable-container-${viewType.toLowerCase()}`,
                        ),
                    );
                },

                2000,
            );
        } else {
            setScrollableElement(document.getElementById('page-content'));
        }
    }, [viewType, activeTab]);

    useEffect(() => {
        if (scrollableElement) {
            scrollableElement.addEventListener('scroll', handleScroll);
        }

        return () => {
            if (scrollableElement) {
                scrollableElement.removeEventListener('scroll', handleScroll);
            }
        };
    }, [scrollableElement, viewType]);

    const handleScroll = throttle(() => {
        const imageElement = document.getElementById('header-image-container');

        if (!scrollableElement) {
            return;
        }

        const newScroll = scrollableElement.scrollTop;
        if (imageElement) {
            const imageHeight = imageElement.offsetHeight;
            const opacity = ((imageHeight - newScroll) / imageHeight) * 0.8;
            imageElement.style.opacity = opacity === 0.8 ? opacity + 0.2 : opacity;
            if (viewType) {
                imageElement.style.height =
                    parseInt(imageElement.style.opacity) === 1
                        ? 'auto'
                        : `${280 - imageElement.style.opacity * 100}
                px`;
            }
            if (newScroll === 0 && setTitleOnHeader && title) {
                setTitleOnHeader('');
            }

            if (newScroll > 96) {
                if (setTitleOnHeader) {
                    setTitleOnHeader();
                }
                imageElement.style.opacity = 0;
                if (viewType) {
                    imageElement.style.height = '97px';
                }
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        }
    }, 100);

    if (!backgroundUrl || disableBanner) {
        return children;
    }

    return (
        <Wrapper>
            {backgroundUrl && (
                <BackgroundImageWrapper id={'header-image-container'} ref={bannerWrapperRef[1]}>
                    {title && (
                        <TitleSection
                            issidepanelopened={isSidepanelOpened}
                            notList={notList}
                            visiblesidemenu={visibleFullSideMenu}
                        >
                            {title && <div>{title}</div>}
                            {subtitle && <div>{subtitle}</div>}
                        </TitleSection>
                    )}
                    <BackgroundImage src={backgroundUrl} alt="Banner" />
                </BackgroundImageWrapper>
            )}
            <Content
                issidepanelopened={isSidepanelOpened}
                notList={notList}
                visiblesidemenu={navigationType === 'sideMenu' && visibleFullSideMenu}
                navigationType={navigationType}
                viewtype={viewType}
                isScrolled={isScrolled}
            >
                {children}
            </Content>
        </Wrapper>
    );
};

export default BrandingBanner;
